import { omit } from 'lodash-es';
const SEARCH_TYPE_OPTION_KEYS = {
    SUBSTRUCTURE: ['useSimilarity'],
    FORMULA: ['formula', 'queryFormula'],
    MASS: ['minMass', 'maxMass', 'massType', 'singleComponent'],
    HAZARD: ['hazardNames', 'hazardSource', 'hazardRoute', 'hazardCategory', 'hazardCode', 'hazardOrganism'],
};
const SIMILARITY_OPTION_KEYS = ['minSimilarity', 'fpType', 'similarityType'];
const getAllTypeSpecificKeys = () => {
    const keysArray = Object.values(SEARCH_TYPE_OPTION_KEYS);
    const allKeys = keysArray.flat();
    return [...new Set(allKeys)];
};
const getAdvancedModeKeys = (options) => options.searchType === 'ADVANCED' ? getAllTypeSpecificKeys() : [];
const getBaseKeys = (options) => {
    const allNonSimilarityKeys = Object.keys(omit(options, SIMILARITY_OPTION_KEYS));
    const allTypeSpecificKeys = getAllTypeSpecificKeys();
    const shouldDropElementFilters = (type, queryFormula) => (type === 'FORMULA' || type === 'ADVANCED') && !queryFormula;
    const allBaseKeys = allNonSimilarityKeys.filter((key) => !allTypeSpecificKeys.includes(key));
    return shouldDropElementFilters(options.searchType, options.queryFormula)
        ? allBaseKeys.filter((key) => !['includeElements', 'excludeElements'].includes(key))
        : allBaseKeys;
};
const getSimilarityKeys = (options) => {
    const shouldIncludeSimilarity = options.searchType === 'SIMILAR' ||
        ((options.searchType === 'SUBSTRUCTURE' || options.searchType === 'ADVANCED') && options.useSimilarity);
    return shouldIncludeSimilarity ? SIMILARITY_OPTION_KEYS : [];
};
const getEffectiveOptionKeys = (options) => {
    if (!options)
        return [];
    return [
        ...new Set([
            ...(SEARCH_TYPE_OPTION_KEYS[options.searchType] || []),
            ...getBaseKeys(options),
            ...getSimilarityKeys(options),
            ...getAdvancedModeKeys(options),
        ]),
    ];
};
export { getEffectiveOptionKeys };
